import React, { useEffect, useState,useContext } from 'react';

import '../Home.css';
import './HomeMobile.css';

import logo from '../../../img/logo.png';
import { Row, Col, Dropdown} from 'antd';
import ImageCarousel from '../../../components/ImageCarousel/ImageCarousel';
import { Link } from 'react-router-dom'
import s0 from '../../../img/s0.jpg';
import s1 from '../../../img/s1.jpg';
import s2 from '../../../img/s2.jpg';
import s3 from '../../../img/s3.jpg';
import path1 from '../../../img/path1.png';
import couple from '../../../img/couple.png';
import { MenuOutlined } from '@ant-design/icons';
import Menu1 from '../../MainMenu/Menu';
import DataCarousel from '../../../components/DataCarousel/DataCarousel';
import LanguageContext from "../../../store/language-context";
import { useTranslation } from "react-i18next";
import { Menu } from 'antd';
import { CustomNavLinkSmallLanguage } from "./styles"
import i18next from 'i18next';
import Footer from 'components/Footer/Footer';
import CardCarousel from 'components/CardCarousel/CardCarousel';

const images = [s0, s1, s2, s3];

const HomeMobile = () => {
  const controller = new AbortController();
  const { signal } = controller;
  const { t, i18n } = useTranslation()

  var currentLanguageCode = i18next.resolvedLanguage;
  const languageCtx = useContext(LanguageContext);
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [pois, setPois] = useState([]);

  const [open, setOpen] = useState(false);

  const handleClick = (key) => {
    i18n.changeLanguage(key);
    languageCtx.languageCodeHandler();
  };

  const menu = (
    <Menu className="menu"
      onClick={(item) => handleClick(item.key)}
      items={[
        {
          key: 'el',
          label: 'ΕΛ',
        },
        {
          key: 'en',
          label: 'EN'
        },
        {
          key: 'fr',
          label: 'FR',
        },
        {
          key: 'de',
          label: 'DE',
        },
      ]}
    />
  )

  useEffect(() => {
    getCategoryPois()
      .then((res1) => {
        // console.log(res1);
        setPois(res1.success)
      })
      .catch((e) => {
        console.log(e.message)
      })
  }, [])

  const getCategoryPois = async () => {
    const url = `https://dimosapokoronou.mitos.cityguideplatform.com/api/pois?category_id=1&lang=${currentLanguageCode}`
    const response = await fetch(url,
      {
        signal,
        headers: {
          'X-API-KEY': 'OHiqSkWShHTbMGLoB5Am',
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      })
    if (!response.ok) {
      throw new Error('Data could not be fetched!')
    }
    else {
      return response.json()
    }
  };

  return (
    <div className={`mobile-horizontal-scroll-container ${isMenuOpen ? 'menu-open' : ''}`}>
      {/* side menu */}
      <Menu1 open={open} setOpen={setOpen} />

      {/* menu button */}
      <div
        className="burger-icon"
        onClick={() => setOpen(true)}
        style={{ top: 20, zIndex: 1, cursor: 'pointer' }}
      >
        <MenuOutlined className='menu-burger' />
      </div>

      {/* main page container */}
      <div className="section1" style={{padding: '1rem'}}>
        {/* header logo */} 
        <div className="logo-container">
          <img src={logo} className="logo" alt="logo" />
        </div>

        {/* section 1 */}
        <div className="section1-container">
          {/* section description */}
          <div>
            <h2 className="section1Title">{t('Ανακαλυψε τα Μουσεια του Δημου Αποκορωνου')}</h2>  
            <p className="section1Description">{t('Καλώς ήρθατε στη διαδικτυακή πύλη που σας προσκαλεί να ανακαλύψετε την πλούσια πολιτιστική κληρονομιά του Δήμου Αποκορώνου. Εξερευνήστε τα εκθέματα των τοπικών μουσείων και γνωρίστε μέσα από αυτά την ιστορία και τις παραδόσεις της περιοχής μας.')}</p>
          </div>

          <button className="museumsButton"><Link to="/museums" style={{textDecoration: 'none'}}>{t("Μουσεία")}</Link></button>

          {/* carousel */}
          <ImageCarousel images={images}/>
          
          {/* couple overlay */}
          <img src={couple} alt="couple" style={{ position: 'relative', width: '100%' }} />
        </div>
      </div>
     
      {/* section 2 */}
      <div className="mobile-section2">
        <div className="mobile-section21" style={{ position: 'relative' }}>
          <div className="mobile-section22" style={{ position: 'relative' }}>
            <DataCarousel/>
          </div>
        </div>
      </div>

      {/* in between sections image */}
      <img className="pathImage" src={path1}/>
 
      {/* section 3 */}
      <div className="mobile-section3">
        <h2 className="museumsTitle" style={{margin: '1rem'}}>{t('Μουσεία')}</h2>
        <CardCarousel museums={pois} />
      </div>

      <Footer />

      {/* footer */}
      {/* <div className="footerHomeMobile">
        <CustomNavLinkSmallLanguage>
          <Dropdown overlay={menu} >
            <a href="#!" onClick={(e) => e.preventDefault()}><span style={{ display: 'none' }}>Map</span>
              <span className="whitebubble" style={{ position: 'relative', color: 'black', top: '4px' }}> {currentLanguageCode === 'el' && 'ΕΛ'} {currentLanguageCode === 'en' && 'ΕΝ'} {currentLanguageCode === 'fr' && 'FR'} {currentLanguageCode === 'de' && 'DE'}</span>
            </a>
          </Dropdown>
        </CustomNavLinkSmallLanguage>  
      </div> */}
    </div>
  );
};

export default HomeMobile;